import React, { useEffect, useState, useCallback } from "react";
import BrainDumpSheet from "./BrainDumpSheet";
import useShortcuts from "../hooks/useShortcuts";

/**
 * GlobalBrainDump — mounts the BrainDumpSheet globally and wires Cmd+N / n
 * to open it from anywhere in the app.
 *
 * Also listens for a custom "open-brain-dump" event so other UI (mobile FAB,
 * future triggers) can request the sheet without importing this component.
 */
export default function GlobalBrainDump() {
  const [open, setOpen] = useState(false);

  const openSheet = useCallback(() => setOpen(true), []);

  // Cmd+N is reserved by Chrome for "New Window" and can't reliably be overridden.
  // Rebound to Cmd+Shift+K (Slack-style quick-switcher feel). Also responds to the
  // custom "open-brain-dump" event so the mobile FAB and any future trigger can open it.
  useShortcuts(
    [
      {
        keys: "mod+shift+k",
        description: "Brain dump (quick capture)",
        group: "Global",
        handler: openSheet,
      },
    ],
    { enabled: true }
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const handler = () => openSheet();
    window.addEventListener("open-brain-dump", handler);
    return () => window.removeEventListener("open-brain-dump", handler);
  }, [openSheet]);

  return <BrainDumpSheet open={open} onOpenChange={setOpen} />;
}
